import styled from 'styled-components';

export default styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: auto;
	gap: var(--gap);
`;
